/** Retrieve BM-Telemetry header. Used to protect the endpoint from enumeration attacks */
export default (): { 'BM-Telemetry': string } | undefined => {
  if (window.bmak && typeof window.bmak.get_telemetry === 'function')
    return { 'BM-Telemetry': window.bmak.get_telemetry() };
  return undefined;
};
